import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';
import { MusicPageComponent } from './pages/music-page/music-page.component';
import { ProducsoundsPageComponent } from './pages/producsounds-page/producsounds-page.component';
import { EnterprisePageComponent } from './pages/enterprise-page/enterprise-page.component';
import { LoginSpaceComponent } from './pages/login-space/login-space.component';
import { SignUpSpaceComponent } from './pages/sign-up-space/sign-up-space.component';
import { TermsComponent } from './pages/terms/terms.component';
import { PrivacyComponent } from './pages/privacy/privacy.component';
import { AuthGuard } from '../app/guards/auth.guard';
import { AdminGuard } from './guards/admin.guard';
import { AdminLoginComponent } from './pages/admin-login/admin-login.component';
import { SoundsvideoComponent } from './pages/soundsvideo/soundsvideo.component';
import { BoutiquePageComponent } from './pages/boutique-page/boutique-page.component';

export const routes: Routes = [
  // Routes principales - traduction dynamique sans préfixe de langue
  {
    path: '',
    component: HomeComponent,
    data: { animation: 'HomePage' }
  },
  {
    path: 'music',
    component: MusicPageComponent,
    data: { animation: 'MusicPage' }
  },
  {
    path: 'producsounds',
    component: ProducsoundsPageComponent,
    data: { animation: 'Producsounds' }
  },
  {
    path: 'enterprise',
    component: EnterprisePageComponent,
    data: { animation: 'EnterprisePage' }
  },
  {
    path: 'soundsvideo',
    component: SoundsvideoComponent,
    data: { animation: 'SoundsvideoPage' }
  },
  {
    path: 'boutique',
    component: BoutiquePageComponent,
    data: { animation: 'BoutiquePage' }
  },
  {
    path: 'login',
    component: LoginSpaceComponent,
    data: { animation: 'LoginSpace' }
  },
  {
    path: 'admin-login',
    component: AdminLoginComponent,
    data: { animation: 'AdminLogin', robots: 'noindex, nofollow' }
  },
  {
    path: 'admin-signup',
    loadComponent: () => import('./pages/admin-signup/admin-signup.component').then(m => m.AdminSignupComponent),
    data: { animation: 'AdminSignup', robots: 'noindex, nofollow' }
  },
  {
    path: 'signup',
    component: SignUpSpaceComponent,
    data: { animation: 'SignUpSpace' }
  },
  {
    path: 'terms',
    component: TermsComponent,
    data: { animation: 'TermsPage' }
  },
  {
    path: 'privacy',
    component: PrivacyComponent,
    data: { animation: 'PrivacyPage' }
  },
  {
    path: '404',
    component: NotFoundPageComponent
  },
  // Section privée (dashboard)
  {
    path: 'dashboard',
    loadChildren: () => import('./private/private-routing.module').then(m => m.PrivateRoutingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('../app/private/admin/admin-routing.module').then(m => m.AdminRoutingModule),
    canActivate: [AuthGuard, AdminGuard]
  },
  // Redirection finale pour toutes les routes inconnues
  { path: '**', redirectTo: '/404' }
];
